import { Component } from '@angular/core';
import { GroupPageBase } from '../social-group/group-page.base';

/** A game's group: the game master and the players. Same page as a map group. */
@Component({
  selector: 'app-social-game-group',
  templateUrl: '../social-group/social-group.component.html',
  styleUrls: ['../social-group/social-group.component.scss'],
  standalone: false,
})
export class SocialGameGroupComponent extends GroupPageBase {
  readonly kind: 'map' | 'game' = 'game';
  protected routeParam = 'gameGroupId';

  protected fetchGroup(id: number) {
    return this.social.getGameGroup(id);
  }

  protected fetchPosts(id: number, page: number) {
    return this.social.getFeed({ gameGroup: id, page });
  }

  protected fetchMembers(id: number) {
    return this.social.getGameGroupMembers(id);
  }
}
